import { PaletteMode, ThemeOptions } from "@mui/material";
import { darkTheme } from "./dark-theme";
import { lightTheme } from "./light-theme";
export const poperSxProps = {
  border: "1px solid #353536",
  padding: "0.5625rem 1rem",
  background: "rgba(0, 0, 0, 0.8)",
  borderRadius: "0.9375rem",
  backdropFilter: "blur(1.25rem);",
};
export const getDesignTokens = (mode: PaletteMode): ThemeOptions => ({
  palette: {
    mode,
    ...(mode === "light" ? lightTheme : darkTheme),
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        disableFocusRipple: true,
        variant: "contained",
        size: "medium",
      },
      styleOverrides: {
        containedPrimary: ({ theme }) => ({
          backgroundColor: theme.palette.primary.light,
        }),
        textPrimary: ({ theme }) => ({
          color: theme.palette.primary.light,
        }),
        outlinedPrimary: ({ theme }) => ({
          color: theme.palette.primary.light,
          borderColor: theme.palette.primary.light,
        }),
        outlinedSecondary: ({ theme }) => ({
          borderColor: theme.palette.secondary.main,
        }),
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: "unset",
          background: "unset",
          borderWidth: mode === "dark" ? 0 : 1,
          border: "0px solid",
          borderColor: "#353536",
        },
      },
      defaultProps: { variant: "outlined" },
    },
    MuiLink: {
      styleOverrides: {
        root: ({ theme }) => ({ textDecoration: "none", color: theme.palette.secondary.main }),
      },
    },
    MuiDialog: {
      defaultProps: {
        scroll: "body",
      },
      styleOverrides: {
        paper: {
          background: mode === "dark" ? "rgba(0, 0, 0, 0.8)" : "#FFFFFF",
          padding: "1.85rem",
          borderRadius: "1.3rem",
          width: "100%",
          backdropFilter: "blur(2.5rem)",
          border: "1px solid #353536",
          "& .MuiDialogTitle-root": {
            marginBottom: "1.85rem",
            padding: 0,
          },
          "& .MuiDialogContent-root": {
            padding: 0,
          },
          "& .MuiDialogActions-root": {
            marginTop: "1.875rem",
            padding: 0,
          },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: poperSxProps,
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {},
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {},
      },
    },
  },
  typography: {
    fontFamily: "'Commissioner', sans-serif",
    button: {
      textTransform: "none",
    },
  },
  breakpoints: {
    values: { xs: 0, sm: 600, md: 900, lg: 1280, xl: 1536 },
  },
});
